const IS_LOCAL_TEST = process.env.NEXT_PUBLIC_IS_LOCAL_TEST === "true";
const IS_DEVELOPMENT_MODE = process.env.NODE_ENV === "development";
const IS_PRODUCTION_MODE = process.env.NODE_ENV === "production";

/**
 * Конфигурация включения/выключения функций проекта
 * @description
 * Содержит флаги для управления доступностью различных функций и технологий
 */
export const FEATURE_FLAGS = {
  /**  Функции для тестового окружения */
  IS_LOCAL_TEST,

  /**  Функции для dev окружения */
  IS_DEVELOPMENT_MODE,

  /**  Функции для production окружения */
  IS_PRODUCTION_MODE,

  /** рисовалка */
  IS_DRAW_ENABLED: true,

  /** автомаска */
  IS_AUTOMASK_ENABLED: true,

  /** реюз лица */
  IS_REMIX_ENABLED: true,

  /** оживление результата */
  IS_ANIMATION_ENABLED: true,

  /** клипы (AiRequest)  */
  IS_CLIPS_ENABLED: true,

  /** кнопка установки PWA */
  IS_PWA_ENABLED: true,

  /** загрузка фото из инстаграм */
  IS_INSTAGRAM_UPLOAD_ENABLED: false,

  /** мужской гендер для настроек */
  IS_MEN_SETTINGS_ENABLED: false,

  /** отправка отзыва  */
  IS_FEEDBACK_ENABLED: true,

  /** баннера  */
  IS_OFFERS_ENABLED: true,

  /** светлая тема  */
  IS_LIGHT_THEME_ENABLED: IS_LOCAL_TEST,

  /** автоопределение темы по браузеру  */
  IS_DETECT_THEME_ENABLED: false,

  /** браузерные пуши  */
  IS_BROWSER_NOTIFICATIONS_ENABLED: true,

  /** вибрация телефона  */
  IS_DEVICE_VIBRATION_ENABLED: true,
} as const;

/**
 * Проверка наличия всех необходимых переменных окружения
 */
Object.entries(FEATURE_FLAGS).forEach(([key, value]) => {
  if (typeof value !== "boolean") {
    console.error(`Отсутствует значение для флага: ${key}`);
    throw new Error(`Отсутствует значение для флага: ${key}`);
  }
});
